import {EChannelType} from 'src/constants';
import {ELicensePeriod} from 'src/containers/Licenses/definitions';
import {
  ESmsTrafficType,
  EViberTrafficType,
  EWhatsappTrafficType,
} from 'src/containers/TariffsCatalog';

export default {
  allTariffs: {
    addTariff: 'Добавить тариф',
    tariffOption: 'Тариф {{channelType}}',
    connectedTariffs: 'Подключенные тарифы',
    availableTariffs: 'Доступные тарифы',
  },
  availableTariffs: {
    title: 'Доступные каналы и тарифы',
    channels: 'Доступные для подключения каналы',
    tariffs: 'Тарифы канала',
    noTariffsChannel:
      'Заполните заявку регистрации канала <0>здесь</0> и получите условия тарификации от менеджера',
  },
  selectTariff: 'Выберите тариф',
  tariffCard: {
    tariff: 'Тариф:',
    channel: 'Канал: ',
    activeFrom: 'Дата активации:',
    willChange: 'Изменится {{date}}',
    willChangeTariff: 'Запланирован переход на другой доступный тариф {{date}}',
    linkedSubjects: 'привязанные каналы',
    linkedTariff: 'доступный тариф {{name}}',
    pricing: 'Из чего состоит тариф?',
    history: 'История изменения',
    invisible: 'Тариф скрыт для клиента',
    connect: 'Подключить',
    options: 'Тариф включает:',
  },
  actions: {
    showSettings: 'Просмотреть настройки',
    showChanges: 'Просмотреть изменения',
    cancelChanges: 'Отменить изменения',
    deleteTariff: 'Удалить тариф',
    changeDate: 'Изменить дату',
    changeTariff: 'Изменить тариф',
    revealTariff: 'Показать тариф клиенту',
  },
  deleteModal: {
    title: 'Удалить тариф?',
    subtitle: 'Тариф будет удален из списка доступных для подключения',
  },
  hideModal: {
    title: 'Скрыть тариф?',
    subtitle:
      'Невозможно удалить тариф из доступных, пока есть <0>связанные с ним подключенные тарифы</0>. Скрыть тариф из Личного кабинета клиента?',
    submitButton: 'Скрыть тариф',
    successNotification: 'Доступный тариф {{name}} скрыт из Личного кабинета.',
  },
  cancelChangesModal: {
    title: 'Отменить запланированные изменения?',
    subtitle: 'Изменения, запланированные ранее с этим тарифом, не вступят в силу в указанный срок',
    submitButton: 'Отменить изменения',
  },
  linkedSubjectsModal: {
    title: 'Каналы, использующие тариф:',
  },
  changePlannedDateModal: {
    title: 'Скорректировать дату изменения тарифа',
    setNewDate: 'Поставьте новую дату изменения тарифа',
    plannedDate: 'Запланированная дата изменения тарифа',
    newDate: 'Новая дата изменения тарифа',
    submitButton: 'Скорректировать',
  },
  editTariffModal: {
    plannedTitle: 'Запланированное изменение тарифа',
    activeTitle: 'Запланированное изменение тарифа',
    settingsTitle: 'Параметры тарифа {{name}}',
    modifyTitle: 'Модифицировать тариф {{name}}',
    title: 'Изменить тариф {{name}}',
    plannedInfo: 'Запланированное изменение вступит в силу {{date}}',
    baseTariff: 'Базовый тариф',
    coefficients: 'Примененные коэффициенты',
    coefficientsHint:
      'Чтобы изменить стоимость тарифа для клиента, измените примененные коэффициенты',
    modifyHint:
      'Чтобы изменить стоимость тарифа для клиента, измените коэффициенты базового тарифа',
    coefficient: 'Коэффициент',
    baseLicensePrice: 'Базовая стоимость лицензии,  {{currency}}',
    licensePrice: 'Итоговая стоимость лицензии,  {{currency}}',
    baseConnectionFee: 'Базовая стоимость подключения,  {{currency}}',
    connectionFee: 'Итоговая стоимость подключения,  {{currency}}',
    baseAmau: 'Базовая стоимость AMAU,  {{currency}}',
    amau: 'Итоговая стоимость AMAU,  {{currency}}',
    createButton: 'Создать тариф',
    planButton: 'Запланировать изменения',
  },
  confirmEditModal: {
    title: 'Запланировать изменение тарифа?',
    hint: 'Доступный тариф изменится 1-го числа следующего месяца',
    linkedTariffHint:
      'Доступный тариф изменится с 1-го числа следующего месяца, <0>связанные подключенные тарифы</0> изменятся при следующей пролонгации лицензии',
    submitButton: 'Запланировать',
  },
  createTariffModal: {
    title: 'Создать доступный тариф {{channelType}} для клиента',
    parameters: 'Параметры тарифа',
    period: 'Период действия тарифа',
    selectBaseTariff: 'Выберите базовый тариф',
    mauCount: 'Количество MAU в период',
    monthLicensePrice: 'Стоимость лицензии,  {{currency}} в месяц',
    licensePrice: 'Стоимость лицензии,  {{currency}}',
    connectionFee: 'Стоимость подключения,  {{currency}}',
    amauPrice: 'Стоимость AMAU,  {{currency}}',
    modifyTariffButton: 'Модифицировать тариф',
    submitButton: 'Создать тариф',
  },
  editConnectedTariffModal: {
    title: 'Изменить активный тариф {{channelType}} для клиента',
    planButton: 'Запланировать',
    period: 'Период действия тарифа',
    parameters: 'Параметры текущего тарифа',
    createTariffButton: 'Создать тариф',
    nextTariff: 'Будущий тариф',
    willChangeAt: 'Тариф изменится в ближайшую дату пролонгации лицензии – {{date}}',
    selectNextTariff: 'Выберите доступный тариф, на который планируется переход',
    onlyTargetTariffHint:
      'У клиента только один доступный тариф, который уже используется. Добавьте тариф в доступные, чтобы перевести на него лицензию.',
  },
  historyModal: {
    title: 'История изменения тарифа',
    changeDate: '{{date}} Тариф изменен',
    connectDate: '{{date}} Тариф подключен',
  },
  licensePeriod: {
    [ELicensePeriod.MONTH]: 'Месяц',
    [ELicensePeriod.YEAR]: 'Год',
  },
  pricesIsWithoutVat: '*Стоимость указана без НДС',
  successNotifications: {
    createTariff: 'Доступный тариф {{name}} добавлен клиенту.',
    changeTariff: 'Доступный тариф {{name}} изменен.',
    changeConnectedTariff: 'Подключенный тариф {{name}} изменен.',
    addTariff: 'Доступный тариф {{name}} добавлен клиенту.',
    cancelChanges: 'Запланированные изменения для тарифа {{name}} отменены.',
    hideTariff: 'Доступный тариф {{name}} скрыт из Личного кабинета.',
    deleteTariff: 'Доступный тариф {{name}} удален.',
  },
  tariffSelect: {
    label: 'Тариф для канала',
    hint: 'Выберите из доступных вам тарифов. <0>Ваши доступные тарифы</0> <1></1>',
    placeholder: 'Выберите тариф',
  },
  pricing: {
    vatHint:
      'Стоимость сообщений списываем с баланса в валюте вашего Личного кабинета. Цены указаны без НДС',
    more: 'Подробнее',
  },
  priceByPeriod: '{{price}}\u00a0{{currency}}\u00a0/\u00a0{{period}}',
  smsPricing: {
    licensePrice: 'Оплата Лицензии за канал: ',
    licensePriceHint: '{{licensePrice}}\u00a0{{currency}} в месяц за всех отправителей',
    detailPricing: 'Оплата услуг:',
    detailPricingHint: '<0>Абонентская плата и отправленные SMS согласно Прайсу</0>',
    pricingHint: '—\nЦены указаны без НДС. НДС применяется согласно действующему законодательству.',
    messagePriceLink: 'Прайс за сообщения',

    modalTitle: 'Тариф SMS согласно прайсу',
    pricingType: 'Тип тарификации:',
    recurrentAmount: 'Абонентская плата за имя отправителя:\n<0>{{price}}\u00a0{{currency}}</0>',
    templateAmount:
      'Стоимость операторского шаблона:\n<0>{{price}}\u00a0{{currency}} / 1 шаблон</0>',
    feePricing: 'Стоимость сообщений:',
    messagePrice: 'Цена сообщения:\n<0>{{price}}\u00a0{{currency}}</0>',
    messagesLimit: 'Количество сообщений',
    upperLimit: 'Свыше {{limit}}',
    mauTitle: {
      [ESmsTrafficType.ADV]: 'Стоимость рекламных сообщений:',
      [ESmsTrafficType.SERVICE]: 'Стоимость сервисных сообщений:',
      [ESmsTrafficType.AUTH]: 'Стоимость авторизационных сообщений:',
      [ESmsTrafficType.INFO]: 'Стоимость информационных сообщений:',
      [ESmsTrafficType.MARKETING]: 'Стоимость маркетинговых сообщений:',
    },
    packageLimit: 'Пакет смс по уникальному абоненту',
    packagePrice: 'Стоимость пакета без НДС, {{currency}}',
    packageLimits: {
      exact: '{{count}} SMS на абонента',
      range: '{{from}} – {{to}} SMS на абонента',
      from: 'От {{from}} SMS на абонента',
    },
    perMessage: '{{price}} / каждое SMS',
    traffic: {
      [ESmsTrafficType.SERVICE]: 'Стоимость сервисного сообщения, {{currency}}',
      [ESmsTrafficType.AUTH]: 'Стоимость авторизационного сообщения, {{currency}}',
      [ESmsTrafficType.MARKETING]: 'Стоимость маркетингового сообщения, {{currency}}',
      [ESmsTrafficType.ADV]: 'Стоимость рекламного сообщения, {{currency}}',
      [ESmsTrafficType.INFO]: 'Стоимость рекламного сообщения, {{currency}}',
    },
  },
  viberPricing: {
    licensePrice: 'Оплата Лицензии за канал: ',
    licensePriceHint: '{{licensePrice}} {{currency}} в месяц за всех отправителей',
    detailPricing: 'Оплата услуг:',
    detailPricingHint: '<0>Платные сообщения Viber согласно Прайсу</0>',
    packagePrice: 'Минимальный платеж за сообщения в месяц {{packagePrice}}\u00a0{{currency}}',
    pricingHint: '—\nЦены указаны без НДС. НДС применяется согласно действующему законодательству.',
    packagePriceShort: 'Минимальный платеж ',
    packagePriceShortHint:
      'Фиксированная сумма в месяц, даже если вы отправили сообщений на меньшую стоимость. Это требование мессенджера за использование официального имени отправителя. Если за месяц вы отправили больше — платите только за фактический объем.',
    modalTitle: 'Стоимость сообщений Viber',
    pricing: 'Стоимость сообщений, цены указаны в {{currency}}',
    country: 'Страна',
    traffic: {
      [EViberTrafficType.SERVICE]: 'Сервисный трафик',
      [EViberTrafficType.MARKETING]: 'Рекламный трафик',
    },
    trafficPricing: 'Стоимость трафика',
  },
  whatsappPricing: {
    licensePrice: 'Оплата Лицензии за канал: ',
    licensePriceHint:
      '{{licensePrice}} {{currency}} в {{period}} за {{mauCount}} активных клиентов (MAU) в месяц.\n' +
      '{{amauPrice}} {{currency}} за каждого клиента сверх {{mauCount}} MAU.',
    detailPricing: 'Оплата услуг:',
    detailPricingHint:
      '<0>Платные сообщения WhatsApp согласно Прайсу</0><br/>' +
      '<1>Какие сообщениях WhatsApp считает бесплатными?</1><2></2>',
    connectionFee: 'Подключение канала',
    connectionFeeHint: '{{connectionFee}} {{currency}} - списываем один раз.',
    pricingHint:
      '—\nЦены указаны без НДС. НДС применяется согласно действующему законодательству.\n*MAU — это уникальный номер телефона, который отправил или получил от вас сообщение в течение месяца',

    modalTitle: 'Стоимость сообщений WhatsApp',
    pricing: 'Стоимость сообщений, цены указаны в {{currency}}',
    country: 'Страна',
    traffic: {
      [EWhatsappTrafficType.AUTHENTICATION]: 'Авторизацион.',
      [EWhatsappTrafficType.MARKETING]: 'Маркетинговые \nCloud API',
      [EWhatsappTrafficType.MARKETING_LITE]: 'Маркетинговые \nMM API',
      [EWhatsappTrafficType.SERVICE]: 'Нешаблонные',
      [EWhatsappTrafficType.UTILITY]: 'Служебные',
    },
    serviceHint: 'Нешаблонные сообщения начинают тарифицироваться с 1001-го доставленного в месяц.',
    trafficPricing: 'Стоимость трафика',
    mauHint:
      'MAU (Monthly Active Users) — уникальные номера телефонов, которые обменивались с вами сообщениями за месяц',
    amauPrice: 'Цена за AMAU: {{amauPrice}}{{currency}} без НДС',
    mauCount: '{{mauCount}} MAU* <0></0>',
  },
  licensePricing: {
    licensePrice: 'Оплата Лицензии за канал: ',
    licensePriceHint: '{{licensePrice}} {{currency}} в месяц за каждого отправителя',
    pricingHint: '—\nЦены указаны без НДС. НДС применяется согласно действующему законодательству.',
  },
  channelHint: {
    [EChannelType.SMS]:
      'Классические SMS-рассылки с максимальным охватом. Отправка через прямые подключения к операторам, контроль доставки и статистика.',
    [EChannelType.MAX]:
      'Персонализированные рассылки в мессенджере MAX. Промо-акции, транзакционные уведомления и информирование клиентов.',
    [EChannelType.MAX_BOT]:
      'Чат-бот в мессенджере MAX для автоматизации диалогов. Отвечает на вопросы, запускает сценарии и обрабатывает обращения 24/7 без участия оператора.',
    [EChannelType.VIBER]:
      'Рассылки и двусторонние диалоги в Viber. Богатый медиаконтент — картинки, кнопки, файлы.',
    [EChannelType.WHATSAPP]:
      'Рассылки и двусторонние диалоги в WhatsApp. Шаблонные уведомления, интерактивные кнопки, медиафайлы и вложения. Отслеживание переходов по кнопкам. Самый популярный мессенджер в мире',
  },
  tariffOptions: {
    [EChannelType.SMS]: ['Каскады', 'Интеграция API'],
    [EChannelType.MAX]: [
      'Входящие и исходящие сообщения',
      'Диалоги',
      'Сценарии',
      'Каскады',
      'Интеграция API',
    ],
    [EChannelType.MAX_BOT]: [
      'Входящие и исходящие сообщения',
      'Диалоги',
      'Сценарии',
      'Каскады',
      'Интеграция API',
    ],
    [EChannelType.VIBER]: ['Каскады', 'Интеграция API'],
    [EChannelType.WHATSAPP]: ['Coexistence', 'Сценарии', 'Интеграция API'],
    [EChannelType.TELEGRAM]: [
      'Входящие и исходящие сообщения',
      'Диалоги',
      'Сценарии',
      'Каскады',
      'Интеграция API',
    ],
  },
  acceptTariffs: {
    banner:
      'Ознакомьтесь с тарифами и нажмите кнопку "{{buttonName}}". После принятия тарифы активируются',
    acceptTariffs: 'Принять тарифы',
    fine: 'Хорошо!',
    modalTitle: 'Примите ваши тарифы',
  },
  acceptTariffsModal: {
    title: 'Примите ваши тарифы',
    description:
      'Ознакомьтесь с тарифами и нажмите кнопку "{{buttonName}}". После принятия тарифы станут доступными для регистрации каналов',
  },
};
